import { REQUEST_TYPE_PRICE_UPDATE } from '@components/bid_request/RequestConstants';
import type { EventRequest } from 'types';

export interface BuyerOnlyPriceRows {
  showBaselinePricePerUnit: boolean;
  showNegotiationStartingPrice: boolean;
}

/**
 * Which buyer-only price columns the buyer grid actually has for this event, so the drawer lists
 * exactly those and never claims a fixed column that does not exist. Proof:
 * `components/bid_request/details/utils/pricingColumns.ts` (`pricingColumnConfigs`) adds the fixed
 * Baseline Price per Unit and Negotiation Starting Price columns on every event that is not a price
 * update (`generateTableConfiguration.tsx`, `useSplit = !isPriceUpdate`). A price update keeps the
 * single price column, which follows the Price per Unit rename, so it lists neither row.
 */
export const buyerOnlyPriceRowsFor = (request: EventRequest): BuyerOnlyPriceRows => {
  const hasSplitPriceColumns = request.request_type !== REQUEST_TYPE_PRICE_UPDATE;

  return {
    showBaselinePricePerUnit: hasSplitPriceColumns,
    showNegotiationStartingPrice: hasSplitPriceColumns,
  };
};
